import React from 'react'

import './styles.css'
import Menu from '../../components/menu/menu'

const Science = ({open, setOpen}) => {
  return (
    <section>
        <Menu open={open} setOpen={setOpen}/>
        <h2>Science</h2> 
    </section>
  )
}

export default Science